import { Button } from "@/components/ui/button";

const HeroSection = () => {
  const scrollToSignup = () => {
    document.getElementById("signup")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-[85vh] flex items-center justify-center bg-gradient-hero overflow-hidden">
      {/* Subtle decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-64 h-64 bg-primary/5 rounded-full blur-3xl animate-subtle-float" />
        <div className="absolute bottom-20 right-10 w-80 h-80 bg-accent/10 rounded-full blur-3xl animate-subtle-float" style={{ animationDelay: "-3s" }} />
      </div>

      <div className="section-container relative z-10 text-center py-20">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-tight text-foreground animate-fade-up max-w-4xl mx-auto">
          Your best startup idea is buried in a notebook you'll never search.
        </h1>
        
        <p className="mt-6 md:mt-8 text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed animate-fade-up-delay-1">
          Founder Labs Ideas is the simple idea journal built for entrepreneurs who have too many ideas and no system to act on them.
        </p>
        
        <div className="mt-10 animate-fade-up-delay-2">
          <Button variant="cta" size="xl" onClick={scrollToSignup}>
            Get Early Access
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
